import {useAccountInformationValue} from '@/auth/hooks/useAccountInformation'
import {getBookmarkQueryOptions} from '@/lib/bookmark/hooks/useBookmark'
import {useLocale} from '@/lib/locale/locale'

export default memo(function BookmarkUpdater() {
  const [locale] = useLocale()
  const accountInformation = useAccountInformationValue()

  useQuery(
    getBookmarkQueryOptions(
      {
        locale,
        accountInformation,
      },
      {
        refetchInterval: 100000, // every 100s
      },
    ),
  )

  return null
})
